/**
 * Sticky banner shown to authenticated staff who are previewing the storefront
 * while the store is Closed (#38). It makes unmistakably clear that the public
 * is NOT seeing this — they see the holding page — so staff don't mistake the
 * preview for the live, launched site.
 */
export default function PreviewBanner() {
  // Intentionally NOT sticky: PublicLayout's Header is `sticky top-0`, so a
  // second sticky bar at top-0 would have the header scroll underneath it.
  // This banner sits at the very top of the document and scrolls away with the
  // page; the header then docks normally.
  return (
    <div
      role="status"
      className="bg-amber-500 px-4 py-2 text-center text-sm font-semibold text-amber-950"
    >
      Staff preview — the public currently sees the “Coming Soon” page. Orders
      you place here are real.
    </div>
  );
}
